export default __webpack_public_path__ + "static/media/requests.3ed17608.png";